import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/scss/bootstrap.scss";
import AppRouter from "./routes/AppRouter";
import firebase from "./Utils/Firebase";
import User from "./model/User";
import Login from "./pages/Login";
import Loading from "./pages/Loading";
import Manager from "./Utils/Manager";
import LoginRouter from "./routes/LoginRouter";

class App extends React.Component {
  state = {
    loading: true,
    login: false,
  };

  componentDidMount() {
    this.checkAuthentication();
  }

  checkAuthentication = () => {
    let db = firebase.firestore();
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection("config")
          .doc("admins")
          .get()
          .then((r) => {
            console.log("here!");
            if (r.data().emails.includes(user.email)) {
              console.log("here3");
              Manager.getInstance().fetchData();
              this.setState({ login: false, loading: false });
            } else {
              console.log("here2");
              this.logout();
              alert("You are not an admin!");
              this.setState({ login: true, loading: false });
            }
          })
          .catch((r) => {
            alert(r);
          });
      } else {
        this.setState({ login: true, loading: false });
      }
    });
  };

  logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {});
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    if (this.state.login) {
      return (
        <BrowserRouter>
          <LoginRouter />
        </BrowserRouter>
      );
    }
    return (
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    );
  }
}
export default App;

ReactDOM.render(<App />, document.querySelector("#root"));
